import {FC, ReactElement, useCallback, useEffect, useState} from 'react';
import styled from 'styled-components';
import Server from "utils/serviceApi";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "@/state";
import {sleep} from "utils/met";
import Message from "components/toasts/toasts";
import {useTranslation} from "react-i18next";
import {CopyToClipboard} from 'react-copy-to-clipboard'
import useInterval from "hooks/useInterval";
import {useHistory} from "react-router-dom";
import {getUserInfo} from "state/base/reducer";

const Main = styled.div`
  width: 100%;
  padding: 0.72rem 0 0.36rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-size: 100% 100%;
  min-height: 100%;

  a {
    border: solid 0.01rem transparent;
    color: #08BDC7;
    min-width: 90%;
    font-size: 0.16rem;
    border-radius: 0.22rem;
    height: 0.44rem;
    text-align: center;
    line-height: 0.44rem;
    background-image: linear-gradient(#fbfaec, #eff6da), linear-gradient(164deg, rgba(72, 176, 254, 1), rgba(23, 250, 218, 1));
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
`;

const CheckDiv = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 0.72rem 0 0.36rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-size: 100% 100%;
  min-height: 100%;
  font-size: 0.12rem;
  font-weight: 400;
  position: relative;
  color: #333333;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.6rem;
  }

  h1 {
    font-size: 0.18rem;
    padding: 0 0.12rem;
    font-weight: bold;
    line-height: 0.24rem;
    text-align: center;
    color: #08BDC7;
  }

  .card {
    width: 100%;
    margin-top: 0.32rem;
    margin-bottom: 0.18rem;
  }

  .bottom-div {
    position: absolute;
    bottom: 0.32rem;
  }

  .bottom_content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.12rem;
    font-weight: 400;
    color: #08BDC7;
    margin-top: 0.08rem;

    p {
      margin: 0 0.08rem;
    }

    img {
      width: 0.16rem;
    }
  }


  .magnifier {
    height: 1.1rem;
    animation: spin-reverse 2s infinite linear;
  }

  .cirle-move {
    position: absolute;
    top: 2.1rem;
    right: 0.36rem;
    animation: spin 2s infinite linear;
    transform-origin: 0.64rem 0.64rem;
  }

  @keyframes spin {
    to {
      transform: rotate(1turn);
    }
  }

  @keyframes spin-reverse {
    to {
      transform: rotate(-1turn);
    }
  }
`;


const CertificationBtn = styled.div`
  height: 44px;
  background: linear-gradient(135deg, #49ADFF 0%, #1DEECE 100%);
  box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
  border-radius: 22px;
  text-align: center;
  line-height: 32px;
  margin-top: 0.44rem;
  font-weight: 600;
  color: #FFFFFF;
  padding: 5px 6px;
  width: 90%;

  div {
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 4px 10px 0px rgba(67, 178, 203, 0.2);
    border-radius: 22px;
  }
`;
const CompareSuccess: FC = (): ReactElement => {
    const {t} = useTranslation();
        const history = useHistory()
        const dispatch = useDispatch();
    const {account} = useSelector((state: AppState) => state.baseInfo)
    const [messageVal, setMessageVal] = useState('')
    const [checkVisible, setCheckVisible] = useState<boolean>(true)
    const [refresh, setRefresh] = useState<boolean>(false)
    const [refreshCount, setRefreshCount] = useState<number>(0)
    const {
        getCompareCheckData
    } = Server

    useInterval(async () => {
        if (account.name && refreshCount < 10) {
            setRefresh(!refresh)
            setRefreshCount(refreshCount + 1)
        }

    }, 8000)

    useEffect(() => {
        const initData = async () => {
            if (sessionStorage.getItem('recover')) {
              return false
            }
            if (account.name) {
                try {
                    const checkData = await getCompareCheckData({account:account.name,checkerType:'realme'})
                    if(checkData.data){
                        if(checkData.data.samePerson){
                            setCheckVisible(false)
                            setRefreshCount(10)
                        }
                    }

                } catch (e) {
                    console.log(e)
                }

            }else{
                dispatch(getUserInfo());
            }
        }
        void initData()

    }, [account.name,  getCompareCheckData, refresh,dispatch])

    const copyUrlChange = useCallback(
        async (text, result) => {
            if (result) {
                setMessageVal(t('home.Copied'))
                await sleep(2000)
                setMessageVal('')
            }
        },
        [t]
    )
    return (
        <>
            {checkVisible ? <CheckDiv>
                <div className='title'>
                    <h1>{t('home.verified')}</h1>
                </div>
                <img className='card' src={require('img/card.png').default} alt=""/>
                <div className="cirle-move">
                    <img className="magnifier" src={require('img/card_loading.png').default} alt=""/>
                </div>

                <p style={{marginTop: '0.12rem',textAlign:'center',fontSize:'0.12rem',color:'#434347'}}>{t('home.youCheckLater')}</p>
                <div className='bottom-div'>
                    <p >{t('home.contactTelegram')}</p>
                    <CopyToClipboard text="https://t.me/Armonia_AMC" onCopy={copyUrlChange}>
                        <div className='bottom_content'>
                            <img src={require('img/icon_telegram.png').default} alt=""/>
                            <p>https://t.me/Armonia_AMC</p>
                            <img src={require('img/icon_copy.png').default} alt=""/>
                        </div>
                    </CopyToClipboard>
                </div>
            </CheckDiv> : <Main>

                <img src={require('img/img_success.png').default} style={{width: '1.4rem', marginTop: '0.2rem'}} alt=""/>
                <p style={{color: '#131314', fontSize: '0.18rem',marginTop:'0.24rem'}}>{t('home.CongratsFace')}</p>
                <CertificationBtn onClick={() => history.push('/compare')}>
                    <div>{t('home.backToHome')}</div>
                </CertificationBtn>

            </Main>}

            {messageVal && <Message content={messageVal}/>}
        </>
    );
}
;

export default CompareSuccess;
